import * as React from 'react';
import {type Dispatch} from '@packages/systems/flux';
import {undo} from './ContentEditorActionCreators';

type Props = {
  children: React.ReactNode;
  dispatch: Dispatch;
};

export class ContentEditorErrorBoundary extends React.Component<Props> {
  componentDidCatch(error: Error) {
    console.error(
      'There was an error rendering the contentEditor subtree',
      error
    );

    this.props.dispatch(undo());
  }

  render() {
    return this.props.children;
  }
}
